import React from 'react'
import PropTypes from 'prop-types'
import Transition from '../components/help/Transition/Transition'
import { FormProvider } from '../context'
import { Helmet } from 'react-helmet'

const Layout = ({ children, location }) => {
    return (
        <FormProvider>
            <Helmet>
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="manifest" href="/site.webmanifest" />
                <link rel="mask-icon" href="/safari-pinned-tab.svg" color="var(--color-red)" />
                <meta name="msapplication-TileColor" content="#0c1f2f" />
                <meta name="theme-color" content="#ffffff" />
            </Helmet>

            <Transition location={location}>{children}</Transition>
        </FormProvider>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

export default Layout